export const OBJECT_MALFORMED = "OBJECT MALFORMED"
export const UNALLOWED_FILE_TYPE = "UNALLOWED FILE TYPE"
export const VALUE_INVALID = "VALUE INVALID"
export const VALUE_OUT_OF_RANGE = "VALUE OUT OF RANGE"